var _stop, _stop2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPowerS(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  var unique = Math.random().toString(36).substring(2);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "66.626%",
    y1: "107.887%",
    x2: "13.496%",
    y2: "0%",
    id: "logo_power_s_svg__a_".concat(unique)
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02CCE1",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ED96",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#logo_power_s_svg__a_".concat(unique, ")"),
    fillRule: "nonzero",
    width: 36,
    height: 36,
    rx: 6
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.993 26.572l-.01.108a2.642 2.642 0 01-.035.224l-.005.024a2.468 2.468 0 01-.174.534 2.78 2.78 0 01-.258.448 2.873 2.873 0 01-.11.142c-.073.09-.153.174-.237.253l.118-.117a2.651 2.651 0 01-.804.578 2.42 2.42 0 01-.39.143 2.16 2.16 0 01-.1.026l-.048.01c-.043.01-.087.019-.131.026l-.033.005a2.254 2.254 0 01-.177.02c-.07.006-.14.009-.21.009l.104-.002-.063.001h-.04a2.647 2.647 0 01-.248-.011l-.03-.003a2.509 2.509 0 01-.135-.018l-.02-.003-.055-.01a2.584 2.584 0 01-.875-.34l-.018-.01a2.597 2.597 0 01-.284-.207l-.028-.024a2.63 2.63 0 01-.076-.067l-.03-.029-6.79-6.487-.126-.129a2.621 2.621 0 01-.677-1.548 2.596 2.596 0 01-.673 1.542l-.126.128-6.79 6.488-.006.006h-.001l-.095.086-.008.008-.041.034a2.684 2.684 0 01-.65.39l-.063.025-.082.03a2.324 2.324 0 01-.387.102 3.437 3.437 0 01-.188.027l-.03.003a2.528 2.528 0 01-.19.01l-.029.001h-.028l-.095-.001-.005-.001-.09-.004a2.826 2.826 0 01-.197-.022l-.033-.005a2.338 2.338 0 01-.132-.025l-.045-.01-.102-.027-.074-.022a2.13 2.13 0 01-.24-.088l-.064-.028a2.68 2.68 0 01-.635-.41l-.063-.056-.118-.117-.084-.095-.016-.018-.003-.003-.06-.075a2.776 2.776 0 01-.246-.378l-.035-.067a2.93 2.93 0 01-.113-.264l-.008-.021-.008-.022a2.519 2.519 0 01-.037-.115l-.015-.055a2.428 2.428 0 01-.03-.118l-.01-.047a2.395 2.395 0 01-.037-.235A2.678 2.678 0 016 26.39V9.625A2.618 2.618 0 018.61 7a2.617 2.617 0 012.606 2.459l.005.166v10.632l2.382-2.274a2.6 2.6 0 013.69.094 2.62 2.62 0 01.708 1.575c.05-.568.284-1.123.706-1.569a2.6 2.6 0 013.557-.214l.133.12 2.381 2.274V9.631l.006-.166a2.617 2.617 0 012.605-2.459A2.618 2.618 0 0130 9.631v16.766c0 .058-.003.117-.007.175z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPowerS);
export default __webpack_public_path__ + "static/assets/logo_power_s.785db07f.svg";
export { ForwardRef as ReactComponent };